export const authors = [
  {
    title: 'Авторки:',
    names: ['Чынаргул Жумабекова', 'Гулиза Урустамбек кызы'],
  },
  {
    title: 'Верстка и дизайн:',
    names: ['Марк А.'],
  },
  {
    title: 'Консультантка по визуальному сторителлингу:',
    names: ['Азиза Раимбердиева'],
  },
  {
    title: 'Авторка идеи и руководительница проекта:',
    names: ['Катерина Афанасьева'],
  },
  {
    title: 'Редакторки:',
    names: ['Азиза Раимбердиева', 'Кристина Закурдаева'],
  },
  {
    title: 'Иллюстрации:',
    names: ['Татьяна Зеленская'],
  },
  {
    title: 'Менторка проекта:',
    names: ['Катерина Синюк'],
  },
  {
    title: 'Дизайн:',
    names: ['Pangea Digital Dataviz team'],
  },
]
